<template>
  <div v-if="userDataStore.userDetails" class="users-info finished-opening">
    <h1 class="user-name">
      {{ userDataStore.userDetails.firstName }}
      {{ userDataStore.userDetails.lastName }}
    </h1>
    <div class="profile-icon">
      <svg viewBox="0 0 24 24" width="24px" height="24px" aria-hidden="true">
        <g fill="var(--focus-t)" stroke="white" stroke-width="2">
          <circle cx="12" cy="6.5" r="5.5" />
          <path
            d="M20.473,23H3.003c-1.276,0-2.228-1.175-1.957-2.422,.705-3.239,3.029-8.578,10.693-8.578s9.987,5.336,10.692,8.575c.272,1.248-.681,2.425-1.959,2.425Z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Pinia as _Pinia } from 'pinia'

const userDataStore = useUserDataStore(usePinia())
</script>

<style scoped>
.users-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 1.4em 0 0;
  min-height: 2.5em;
  gap: 0.3em;
  --focus: white;
  --focus-t: transparent;
  --trans-dur: 0.3s;
  --trans-timing: cubic-bezier(0.65, 0, 0.35, 1);
}

.user-name {
  position: relative;
  overflow-wrap: break-word;
  font-size: 1em;
  color: white;
  font-weight: 500;
  text-align: right;
  margin: 0;
  text-transform: capitalize;
}

.profile-icon {
  flex-shrink: 0;
  border: 1px solid white;
  padding: 0.1em;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25em;
  aspect-ratio: 1/1;
}

svg {
  margin: 0.25em auto 0;
  width: 1em;
  height: auto;
  display: block;
}

svg circle,
svg path {
  transition: fill calc(var(--trans-dur) / 2) var(--trans-timing);
}

svg circle {
  animation-name: unset;
  animation-duration: 0;
}

.finished-opening svg circle {
  animation-timing-function: var(--trans-timing);
  animation-name: head-bob;
  animation-duration: calc(var(--trans-dur) * 2.5);
}

.users-info:hover svg circle,
.users-info:hover svg path,
.users-info:focus-visible svg circle,
.users-info:focus-visible svg path {
  fill: var(--focus);
}

@media (prefers-reduced-motion) {
  circle {
    animation-duration: 0s;
  }
}

@keyframes head-bob {
  from,
  to {
    transform: translateX(0);
  }
  20% {
    transform: translateX(4px);
  }
  40% {
    transform: translateX(-3px);
  }
  60% {
    transform: translateX(2px);
  }
  80% {
    transform: translateX(-1px);
  }
}
</style>
